import { render, staticRenderFns } from "./TianMuVideoPlanLibrary.vue?vue&type=template&id=1f36d6a7&scoped=true"
import script from "./TianMuVideoPlanLibrary.vue?vue&type=script&lang=js"
export * from "./TianMuVideoPlanLibrary.vue?vue&type=script&lang=js"
import style0 from "./TianMuVideoPlanLibrary.vue?vue&type=style&index=0&id=1f36d6a7&prod&lang=scss&scoped=true"
import style1 from "./TianMuVideoPlanLibrary.vue?vue&type=style&index=1&id=1f36d6a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36d6a7",
  null
  
)

export default component.exports